// @flow
import { APP_NAMESPACE } from "shared/constants/application";

const namespace: string = `${APP_NAMESPACE}/coursePromotions`;

export const GET_PROMOTIONS_REQUEST: string = `${namespace}/PROMOTIONS/FETCH/REQUEST`;
export const GET_PROMOTIONS_REQUEST_SUCCESS: string = `${namespace}/PROMOTIONS/FETCH/SUCCESS`;
export const GET_PROMOTIONS_REQUEST_ERROR: string = `${namespace}/PROMOTIONS/FETCH/ERROR`;
